module.exports = __webpack_public_path__ + "static/media/DASHBOARD-REPORT.1ba3af2a.svg";